<template>
  <v-container  fluid grid-list-md>
  <v-card style="padding: 16px;" class="mx-auto" >
      <v-card-text  class="headline font-weight-bold">
        <v-card-actions class="headline font-weight-bold">
          <div>Minhas Vendas</div>
          <v-spacer></v-spacer>
        </v-card-actions>
        <div style="font-size: 16px; font-weight: 400">
          <h3 style="font-weight: 700">
            Subtotal: {{ $n(subtotal, "currency") }}
          </h3>
          <i>Utilize os Filtros para melhorar a sua busca.</i>
        </div>
        <v-layout align-center justify-end>
          <v-btn fab top right small @click="enableFilters">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <export />
        </v-layout>

      </v-card-text>
      </v-card>

      <payments-table />
    <filters />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Payments',
  components: {
    PaymentsTable: () => import('./PaymentsTable.vue'),
    Filters: () => import('@/components/desktop/sales/Filters.vue'),
    Export: () => import('./Export'),
  },
  computed: {
    ...mapGetters({
      filters: 'payments/filterParams',
      subtotal: 'payments/subtotal',
    }),
  },
  methods: {
    enableFilters() {
      this.$store.dispatch('payments/showFilters', true);
    },
  },
};
</script>
